"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ANNUAL_EXPENSE_FIELD = exports.MONTHLY_EXPENSE_FIELD = exports.WEEKLY_EXPENSE_FIELD = exports.HOURLY_EXPENSE_FIELD = exports.getExpenseTypeObj = exports.getExpenseFieldsList = void 0;
var entities_1 = require("@common/entities");
var getExpenseFieldsList = function (type) {
    var institutionNameLabel = 'Child Care Provider Name';
    if (type === entities_1.ExpenseTypes.Disability || type === entities_1.ExpenseTypes.Medical) {
        institutionNameLabel = 'Doctor/Pharmacy Name';
    }
    return [
        {
            customType: entities_1.FieldType.TextArea,
            enabled: true,
            label: 'Description',
            name: entities_1.IncomeFields.description.name,
            required: true,
            sequence: 1,
            type: entities_1.FieldType.TextArea,
        },
        {
            customType: entities_1.FieldType.Text,
            enabled: true,
            label: institutionNameLabel,
            name: entities_1.IncomeFields.institutionName.name,
            required: true,
            sequence: 2,
            type: entities_1.FieldType.Text,
        },
        {
            customType: entities_1.FieldType.Text,
            enabled: true,
            label: 'Contact Name',
            name: entities_1.IncomeFields.contactName.name,
            required: true,
            sequence: 3,
            type: entities_1.FieldType.Text,
        },
        {
            customType: entities_1.FieldType.PhoneNumber,
            enabled: true,
            label: 'Contact Phone',
            name: entities_1.IncomeFields.contactPhone.name,
            required: true,
            sequence: 4,
            type: entities_1.FieldType.PhoneNumber,
        },
        {
            customType: entities_1.FieldType.PhoneNumber,
            enabled: true,
            label: 'Contact Fax',
            name: entities_1.IncomeFields.contactFax.name,
            required: true,
            sequence: 5,
            type: entities_1.FieldType.PhoneNumber,
        },
        {
            customType: entities_1.FieldType.Email,
            enabled: true,
            label: 'Contact Email',
            name: entities_1.IncomeFields.contactEmail.name,
            required: true,
            sequence: 6,
            type: entities_1.FieldType.Email,
        },
        {
            customType: entities_1.FieldType.Text,
            enabled: true,
            isAddress: true,
            label: 'Address Line 1',
            name: entities_1.InstitutionAddressFields.streetLine1.name,
            required: true,
            sequence: 7,
            type: entities_1.FieldType.Text,
        },
        {
            customType: entities_1.FieldType.Text,
            enabled: true,
            isAddress: true,
            label: 'Address Line 2',
            name: entities_1.InstitutionAddressFields.streetLine2.name,
            required: false,
            sequence: 8,
            type: entities_1.FieldType.Text,
        },
        {
            customType: entities_1.FieldType.Text,
            enabled: true,
            isAddress: true,
            label: 'Address Line 3',
            name: entities_1.InstitutionAddressFields.streetLine3.name,
            required: false,
            sequence: 9,
            type: entities_1.FieldType.Text,
        },
        {
            customType: entities_1.FieldType.Text,
            enabled: true,
            isAddress: true,
            label: 'City',
            name: entities_1.InstitutionAddressFields.city.name,
            required: true,
            sequence: 10,
            type: entities_1.FieldType.Text,
        },
        // {
        //   customType: FieldType.CountryDropdown,
        //   enabled: true,
        //   isAddress: true,
        //   label: 'Country',
        //   name: InstitutionAddressFields.countryCode.name,
        //   options: [],
        //   required: true,
        //   sequence: 11,
        //   type: FieldType.CountryDropdown,
        //   isAddress: true,
        // },
        {
            customType: entities_1.FieldType.StateDropdown,
            enabled: true,
            isAddress: true,
            label: 'State',
            name: entities_1.InstitutionAddressFields.stateCode.name,
            options: [],
            required: true,
            sequence: 12,
            type: entities_1.FieldType.StateDropdown,
        },
        {
            customType: entities_1.FieldType.ZipCode,
            enabled: true,
            isAddress: true,
            label: 'Zip Code',
            name: entities_1.InstitutionAddressFields.postalCode.name,
            required: true,
            sequence: 13,
            type: entities_1.FieldType.ZipCode,
        },
        {
            customType: entities_1.FieldType.Date,
            enabled: true,
            label: 'Start Date',
            name: entities_1.IncomeFields.dateStarted.name,
            required: true,
            sequence: 14,
            type: entities_1.FieldType.Date,
        },
        {
            customType: entities_1.FieldType.Date,
            enabled: true,
            label: 'End Date',
            name: entities_1.IncomeFields.dateEnded.name,
            required: true,
            sequence: 15,
            type: entities_1.FieldType.Date,
        },
    ];
};
exports.getExpenseFieldsList = getExpenseFieldsList;
var getExpenseTypeObj = function (name, label, type) { return ({
    name: name,
    label: label,
    customType: type,
    paymentInterval: entities_1.ExpenseInterval.Monthly,
    elementType: entities_1.SectionElementType.Block,
    fields: (0, exports.getExpenseFieldsList)(type),
}); };
exports.getExpenseTypeObj = getExpenseTypeObj;
exports.HOURLY_EXPENSE_FIELD = [
    {
        customType: entities_1.FieldType.Amount,
        enabled: true,
        label: 'Hourly Expense',
        name: entities_1.ExpenseFields.hourlyExpense.name,
        required: true,
        sequence: 1,
        type: entities_1.FieldType.Amount,
    },
    {
        customType: entities_1.FieldType.Number,
        enabled: true,
        label: 'Hours Per Week',
        name: entities_1.IncomeFields.hourPerWeek.name,
        required: true,
        sequence: 2,
        type: entities_1.FieldType.Number,
    },
    {
        customType: entities_1.FieldType.Number,
        enabled: true,
        label: 'Weeks Per Year',
        name: entities_1.IncomeFields.weekPerYear.name,
        required: true,
        sequence: 3,
        type: entities_1.FieldType.Number,
    },
];
exports.WEEKLY_EXPENSE_FIELD = [
    {
        customType: entities_1.FieldType.Amount,
        enabled: true,
        label: 'Weekly Expense Amount',
        name: entities_1.ExpenseFields.expenseAmount.name,
        required: true,
        sequence: 1,
        type: entities_1.FieldType.Amount,
    },
];
exports.MONTHLY_EXPENSE_FIELD = [
    {
        customType: entities_1.FieldType.Amount,
        enabled: true,
        label: 'Monthly Expense Amount',
        name: entities_1.ExpenseFields.expenseAmount.name,
        required: true,
        sequence: 1,
        type: entities_1.FieldType.Amount,
    },
];
exports.ANNUAL_EXPENSE_FIELD = [
    {
        customType: entities_1.FieldType.Amount,
        enabled: true,
        label: 'Annual Expense Amount',
        name: entities_1.ExpenseFields.expenseAmount.name,
        required: true,
        sequence: 1,
        type: entities_1.FieldType.Amount,
    },
];
